export default __webpack_public_path__ + "static/media/lumen_back.28a1380b.svg";